import styled from "@emotion/styled"
import { getSkeletonStyle } from "@porsche-design-system/components-react/emotion"

export interface SkeletonProps {
	$height?: string
	$width?: string
	className?: string
}

export const SkeletonComponent = (props: SkeletonProps) => {
	return <StyledSkeleton aria-busy="true" {...props} />
}

const StyledSkeleton = styled("div")<SkeletonProps>`
	${getSkeletonStyle()};
	${({ $height }) => $height && `height: ${$height};`};
	${({ $width }) => $width && `width: ${$width};`};
`
